import { Grid2x2Plus } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const MarketplaceIcon = createNavigationLucideIcon(Grid2x2Plus);
